import { CustomImage, CustomModal, CustomPageHeader, Text, useText } from '@src/components';
import CreditCardForm from './creditCardForm';
import CreditCardSummary from './creditCardSummary';
import CreditCardResult from './creditCardResult';
import '@src/styles/companyInformation/creditcards/creditcards.scss';
import { Button, Form, Steps } from 'antd';
import React, { useCallback, useEffect, useMemo } from 'react';
import {
  Cancel,
  finishPaymentProcess,
  processPayment,
  resetEditingCard,
  setCreditCardMatchVous,
  setEditingCard,
} from '@src/store/slice/mobilExpressSlice';
import { useDispatch, useSelector } from 'react-redux';
import uniqBy from 'lodash/uniqBy';
import modalClose from '@src/assets/icons/icon-close.svg';

const { Step } = Steps;

const steps = [
  {
    title: <Text t="CreditCardForm" />,
    content: CreditCardForm,
  },
  {
    title: <Text t="CreditCardSummary" />,
    content: CreditCardSummary,
  },
  {
    title: <Text t="CreditCardResult" />,
    content: CreditCardResult,
  },
];

const Index = () => {
  const companyInformation2 = useText('companyInformation2');
  const threeDSecurity = useText('3dSecurity');
  const dispatch = useDispatch();
  const { editingCard } = useSelector((state) => state?.mobilExpress);
  const { selectedCustomer, customerVouList } = useSelector((state) => state?.customer);
  const { vouIdList } = useSelector((state) => state?.menus);
  const [form] = Form.useForm();
  const [threeDSecureModalVisible, setThreeDSecureModalVisible] = React.useState(false);
  const [threeDSecureContent, setThreeDSecureContent] = React.useState('');

  const current = useMemo(() => {
    if (!editingCard?.current) {
      return 0;
    }
    return editingCard.current;
  }, [editingCard]);

  useEffect(() => {
    dispatch(resetEditingCard());
  }, []);

  const vouList = useMemo(() => {
    return uniqBy(customerVouList, (d) => d.vouId)
      .map((vou) => ({
        vouId: vou.vouId,
        vouName: vou.vouName,
      }))
      .filter((vou) => editingCard?.selectedVou?.includes(vou.vouId));
  }, [customerVouList.length, editingCard]);

  const cancelProvision = async (body) => {
    const cancelAction = await dispatch(Cancel(body));
    setThreeDSecureModalVisible(false);
    if (Cancel.fulfilled.match(cancelAction)) {
      await dispatch(setEditingCard({ current: current + 1 }));
    }
  };
  const finishPaymentProcessHandler = async (body) => {
    const finishPaymentAction = await dispatch(finishPaymentProcess(body));
    if (finishPaymentProcess.fulfilled.match(finishPaymentAction)) {
      const creditCard = editingCard?.creditCard;
      const saveCardAction = await dispatch(
        setCreditCardMatchVous({
          saveCardBody: {
            customerInfo: {
              customerId: selectedCustomer?.customerId.toString(),
            },
            cardHolterName: creditCard.cardHolderName,
            cardNumber: creditCard.cardNumber.split('-').join(''),
            cardMonth: creditCard.lastMonth,
            cardYear: creditCard.lastYear?.toString(),
            selectedVous: vouList,
          },
          creditCartVouMatchList: vouIdList.map((vouId) => ({
            customerId: selectedCustomer?.customerId,
            vouId,
            provisionDay: '0',
            type: editingCard?.automaticPayment ? 1 : 0,
          })),


        }),
      );
      if (setCreditCardMatchVous.fulfilled.match(saveCardAction)) {
        await cancelProvision({
          body: {
            orderId: body.body.orderId,
            paymentInstrument: 'newCard',
            transactionReason: 'Ön Provizyon İptal',
          },
        });
      } else {
        setThreeDSecureModalVisible(false);
        await dispatch(Cancel(body));
      }
    } else {
      setThreeDSecureModalVisible(false);
    }
  };

  const iframeOnLoad = async (queryString) => {
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      const paymentInstrument = urlParams.get('paymentInstrument');
      const orderId = urlParams.get('OrderId');
      const systemTransId = urlParams.get('SystemTransId');

      if (paymentInstrument && orderId && systemTransId) {
        const body = {
          paymentReferenceType: 3,
          referenceId: '1',
          body: {
            orderId,
            merchantProcessId: 'IslemId33',
            systemTransId: systemTransId,
            paymentInstrument: 'NewCard',
            paymentInstrumentInfo: {},
          },
        };

        body.body.paymentInstrumentInfo = {
          newCard: {},
        };
        await finishPaymentProcessHandler(body);
      } else {
        setThreeDSecureModalVisible(false);
      }
    }
  };

  window.finishPaymentProcessHandler = iframeOnLoad;

  const next = useCallback(async () => {
    if (current === 0) {
      await form.validateFields();
      dispatch(setEditingCard({ current: current + 1 }));
    } else if (current === 1) {
      const creditCard = editingCard?.creditCard;
      const body = {
        body: {
          currency: 'TRY',
          paymentInstrument: 'NewCard',
          paymentInstrumentInfo: {
            newCard: {
              processType: 'preauth',
              use3DSecure: true,
              cvv: creditCard?.cvv?.replaceAll('_', ''),
              cardInfo: {
                cardHolderName: creditCard?.cardHolderName?.toString(),
                cardNumber: creditCard?.cardNumber?.toString(),
                lastMonth: creditCard?.lastMonth,
                lastYear: creditCard?.lastYear?.toString(),
              },
            },
          },
          returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=preauth`,
          totalAmount: 1,
          customerInfo: { customerId: selectedCustomer?.customerId?.toString() },
        },
        paymentReferenceType: 3,
        referenceId: '1',
      };

      const actionPayment = await dispatch(processPayment(body));
      if (processPayment.fulfilled.match(actionPayment)) {
        setThreeDSecureModalVisible(true);
        setThreeDSecureContent(
          'data:text/html;charset=utf-8,' +
          encodeURIComponent(actionPayment?.payload?.data?.redirectForm),
        );
      }
    }
  }, [current, editingCard]);

  const StepContent = steps[current]?.content;
  return (
    <CustomPageHeader
      title={<Text t="creditCardList" />}
      showBreadCrumb
      showHelpButton
      routes={[companyInformation2]}
    >
      <div className="credit-card-form-content">
        <Steps current={current} className="credit-card-steps" labelPlacement="vertical">
          {steps.map((item) => (
            <Step key={item.title} />
          ))}
        </Steps>
        <StepContent form={form} />

        <div className="step-btn-content">
          {current < steps.length - 2 && (
            <Button
              id="companyInformation-step-next-btn"
              className="step-next-btn"
              onClick={() => next()}
            >
              <Text t="continue2" />
            </Button>
          )}

          {current === steps.length - 2 && (
            <Button
              id="companyInformation-second-step-next-btn"
              className="step-next-btn"
              onClick={() => next()}
            >
              <Text t="approve2" />
            </Button>
          )}
        </div>
      </div>
      {threeDSecureModalVisible && (
        <CustomModal
          width={500}
          maskClosable={false}
          footer={false}
          title={threeDSecurity}
          visible={threeDSecureModalVisible}
          onCancel={() => setThreeDSecureModalVisible(false)}
          closeIcon={<CustomImage src={modalClose} />}
        >
          <embed src={threeDSecureContent} width="100%" height="400" />
        </CustomModal>
      )}
    </CustomPageHeader>
  );
};

export default Index;
